import axios from "axios";

const IDCARD_HOST = "https://siliconmindstechnologies.com/";

const SaveIdCardTemplate = async ({ payload }) => {
  const formData = new FormData();
  formData.append("id", payload.id || 0);
  formData.append("name", payload.name || "Untitled ID card");
  formData.append("course_url", payload.course_url || "");
  formData.append("svg", payload.svg || "");
  formData.append("width", payload.width || 545);
  formData.append("height", payload.height || 831);
  if (payload.session) formData.append("session", payload.session);

  const res = await axios.post(IDCARD_HOST + "admin-save-idcard-template.php", formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default SaveIdCardTemplate;
